<template>
<div class="page-points-address container">
    <div class="container-flex points-address-list"  :class="addressList.length > 0 ? 'bg' : ''">
        <div class="points-address-item" v-for="(item,index) in addressList" :key="index"  @click="selectClick(item)">
            <div class="points-address-info">
                <div class="points-address-info-flex">
                    <div class="address-name">
                        {{item.receiver}} <span class="phone">{{item.phone}}</span>
                    </div>
                    <div class="address-text">{{item.fullAddress}}</div>
                </div>
                <div class="points-address-up-icon v-center" @click="upItem(item)" v-if="!isSelect">
                    <img class="right-icon" src="../../assets/image/updata.png" />
                </div>
            </div>
            <div class="address-ops" v-if="!isSelect">
                <div class="address-ops-flex">
                    <!-- <img class="radio" src="../../assets/image/radio.png" />
                    <img class="radio" src="../../assets/image/radio-yes.png" />
                    默认地址 -->
                </div>
                <div class="address-del v-center" @click="delItem(item,index)">
                    <img class="address-del-icon" src="../../assets/image/del.png" />
                </div>
            </div>
        </div>
        <div class="no-list-data" v-if="addressList.length > 0">暂无更多数据</div>
        <div class="no-address" v-if="addressList.length == 0">
            <img class="no-address-icon" src="../../assets/image/mall-no-address.png" />
            <div class="no-address-text">暂无地址信息，快去添加吧</div>
        </div>
    </div>
    <div class="add-btn-box">
        <pi-button type="primary" block @click="addressClick">添加收货地址</pi-button>
    </div>
</div>
</template>

<script>
import { getMyMallAddress,delMyMallAddress } from "../../common/api/index";
import { List } from "vant";
export default {
  name: "points-address",
  components: {
   [List.name]: List,
  },
  data() {
    return {
      isSelect: false,
      loading: false,
      isAll: false,
      addressList: []
    };
  },
  methods: {
    async getMyMallAddress(){
      this.loading = true
      let ret = await getMyMallAddress({});
      if (ret.status === 0) {
        let data = ret.data || [];
        this.addressList.push(...data);

        if(this.addressList.length >= ret.total){
          this.isAll = true;
        }
      }
      this.loading = false
    },
    addressClick(){
      this.$router.push("/points-address-add");
    },
    delItem(item,index){
      this.$dialog
        .confirm({
          message: "确定要删除吗",
          confirmButtonText: "确定",
          confirmButtonColor: "#14CC80",
          closeOnPopstate: true
        })
        .then(() => {
          this.delSub(item.pkid,index);
        })
        .catch(() => {});

      // var that = this;
      // wx.showModal({
      //   title: '提示',
      //   content: "确定要删除地址吗?",
      //   success (res) {
      //     if (res.confirm) {
      //       let item = e.currentTarget.dataset.item;
      //       let index = e.currentTarget.dataset.index;
      //       that.delSub(item.pkid,index);
      //     }
      //   }
      // })
    },
    async delSub(addressPkId,index){
      let ret = await delMyMallAddress({
        addressPkId: addressPkId
      })
      if (ret.status === 0) {
        this.$toast('删除成功');
        this.addressList.splice(index,1);
      }
    },
    selectClick(item){
      if(this.isSelect){
        this.$common.save('selectAddress',item);
        this.$common.goBack();
      }
    },
    upItem(item){
      this.$router.push("points-address-add?pkid=" + item.pkid);

      // let item = e.currentTarget.dataset.item;
      // wx.navigateTo({
      //   url: '/pages/points-address-add/points-address-add?pkid=' + item.pkid,
      // })
    }
  },
  mounted() {
    if(this.$route.query.type == 'select'){
      this.isSelect = true;
    }
    this.getMyMallAddress();
  },
};
</script>

<style lang="less">
@import "../../assets/less/old/var.less";
.page-points-address{
    
  .points-address-list{
      padding: 0.20rem;
      position: relative;
  }
  .points-address-item{
      background-color: #fff;
      border-radius: 0.12rem;
      margin-top: 0.20rem;
      font-size: 0.24rem;
      line-height: 0.33rem;
      color: #666;
  }
  .points-address-item:first-child{
      margin-top: 0;
  }
  .points-address-info{
      padding: 0.20rem;
      display: flex;
  }
  .points-address-info-flex{
      flex: 1;
  }
  .points-address-info .address-name{
      font-size: 0.28rem;
      line-height: 0.40rem;
      color: #000;
  }
  .points-address-info .phone{
      margin-left: 0.10rem;
  }
  .points-address-info .address-text{
      margin-top: 0.13rem;
  }

  .address-ops{
      display: flex;
      padding: 0.20rem;
      border-top: 1px solid #F5F4F9;
  }
  .address-ops-flex{
      flex: 1;
  }
  .radio ,.address-del-icon,.right-icon{
      width: 0.30rem;
      height: 0.30rem;
      display: inline-block;
      vertical-align: text-bottom;
  }
  .address-del{
      padding-left: 0.20rem;
  }
  .points-address-up-icon{
      padding-left: 0.20rem;
  }
  .add-btn-box{
    padding: 0.20rem;
  }
  .no-address{
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
      text-align: center;
  }
  .no-address-icon{
      width: 1.50rem;
      height: 0.97rem;
  }
  .no-address-text{
      margin-top: 0.30rem;
      color: #999
  }
}
</style>
